import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneCallIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { phones } from '../data/contact';
const fade = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  transition: {
    duration: 0.35,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function Navbar() {
  const {
    language,
    t
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-26" data-mp="1kyom291sioo3">
      <div className={`transition-all duration-300 ${scrolled ? 'glass border-b border-ink/10 shadow-soft' : 'border-b border-transparent bg-transparent'}`} data-id="element-27" data-mp="9ohk9lwa3jri">
        <nav className="mx-auto flex h-[72px] max-w-shell items-center justify-between px-5 sm:px-8" aria-label={t.nav.ariaLabel} data-id="element-28" data-mp="elzl0p056sof">
          <Logo data-id="element-29" data-mp="jksvs9o1o5kw" />

          <motion.ul key={`links-${language}`} {...fade} className="hidden items-center gap-1 lg:flex" data-id="element-30" data-mp="olgrv9r4rclz">
            {t.nav.links.map(link => <li key={link.href} data-id="element-31" data-mp="3n4ozgs6bmstx">
                <a href={link.href} className="rounded-full px-4 py-2 text-[14px] font-medium text-ink/70 transition-colors hover:bg-ink/[0.04] hover:text-ink" data-id="element-32" data-mp="3n19krqgk7lt1">
                  {link.label}
                </a>
              </li>)}
          </motion.ul>

          <div className="flex items-center gap-3" data-id="element-33" data-mp="5nxoomrcso7h">
            <LanguageSwitcher data-id="element-34" data-mp="5opaj5v5f7kk" />
            <motion.div key={`cta-${language}`} {...fade} className="hidden items-center gap-3 md:flex" data-id="element-35" data-mp="34decgm3pv07b">
              <a href={phones[0].href} className="flex items-center gap-2 text-[14px] font-medium text-ink/70 transition-colors hover:text-ink xl:flex" data-id="element-36" data-mp="39b60h518q268">
                <PhoneCallIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="3196wnbatg4n8" />
                <span className="hidden xl:inline" data-id="element-38" data-mp="2wbng24qnbfs4">{phones[0].display}</span>
              </a>
              <a href="#consultation" className="rounded-full bg-brand px-5 py-2.5 text-[14px] font-semibold text-white shadow-glow transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-600" data-id="element-39" data-mp="3azrs4pv70t1x">
                {t.nav.cta}
              </a>
            </motion.div>

            <button type="button" onClick={() => setOpen(v => !v)} className="flex h-10 w-10 items-center justify-center rounded-xl border border-ink/10 text-ink md:hidden" aria-label={open ? t.nav.closeMenu : t.nav.openMenu} aria-expanded={open} data-id="element-40" data-mp="2de452vkmnn32">
              {open ? <XIcon className="h-5 w-5" data-id="element-41" data-mp="2nduzyyd3o43o" /> : <MenuIcon className="h-5 w-5" data-id="element-42" data-mp="7juokzrjejck" />}
            </button>
          </div>
        </nav>
      </div>

      <AnimatePresence data-id="element-43" data-mp="2m2m5bt9neu4">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.25
      }} className="glass border-b border-ink/10 px-5 pb-6 pt-2 shadow-lift md:hidden" data-id="element-44" data-mp="2krgt7k69z0w">
            <ul className="flex flex-col" data-id="element-45" data-mp="15x7ec92vf1u">
              {t.nav.links.map(link => <li key={link.href} data-id="element-46" data-mp="56qvb5mistuq">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-ink/5 py-3.5 text-[15px] font-medium text-ink" data-id="element-47" data-mp="57s7jdf9vme1">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <a href="#consultation" onClick={() => setOpen(false)} className="mt-5 block rounded-2xl bg-brand px-5 py-3.5 text-center text-[15px] font-semibold text-white shadow-glow" data-id="element-48" data-mp="k3hylpzbeppm">
              {t.nav.mobileCta}
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}